/**
 * TimesAct "Notify me" products: no Add to cart, wherever their cart form is.
 *
 * The TimesAct app (assets/timesact.js) turns the Add to cart button of a product set to "Notify me" (back in
 * stock) into its "Sign Up To Be Notified" button, which opens its sign-up form, but only:
 * - on product pages: the page's product (the sticky bar follows that button, assets/sticky-atc.js);
 * - on collection, search, home and /pages/ pages: the buttons in the product cards it finds (the cards with
 *   the first of its card classes present on the page: .product-item, then .card--standard, …).
 * Any other Add to cart form still adds the product to the cart: product cards and quick-add windows on
 * product pages (You may also like), product forms outside those cards (Featured product), other pages.
 *
 * This script asks the app which products on the page are set to "Notify me", with the app's rule (every
 * variant's back-in-stock setting active). A form's product is read from the closest data-product-id.
 * - Forms the app doesn't cover get the app's label, and a click opens the sign-up form instead of adding to
 *   the cart: through the app's button when it's the page's product, otherwise on the product's page
 *   (#timesact-notify opens the form there).
 * - Forms the app covers are left to it. Until it has replaced their button (it needs a few requests first),
 *   or if it doesn't, submitting them opens the sign-up form instead; after a few seconds without the app's
 *   button they're taken over as above.
 * A failed request to the app is retried a few times.
 */
(function () {
  if (window.timesactNotify) return;
  window.timesactNotify = true;

  var HASH = '#timesact-notify';
  // The app's label for this store, used only if its settings can't be read
  var FALLBACK_LABEL = 'Sign Up To Be Notified';
  var CARD_CLASSES = ['.timesact-badge', '.product-item', '.card--standard', '.card--card', '.ProductItem', '[data-pf-type="ProductBox"], gp-product'];
  var MAIN_PRODUCT = 'product-info[id^="MainProduct-"]:not([data-original-section])';
  var TAKEOVER_DELAY = 4000;

  // The app's own page checks
  var href = window.location.href;
  var isProductPage = href.indexOf('/products/') > -1 || href.indexOf('/products_preview?') > -1;
  var appCoversCards =
    href.indexOf('/collections/') > -1 ||
    href.indexOf('/search?') > -1 ||
    href.indexOf('/pages/') > -1 ||
    window.location.pathname === '/';

  // The app's button for the page's product, while it shows
  function appButton() {
    var button = document.querySelector(MAIN_PRODUCT + ' .timesact-button-bis');
    return button && button.getClientRects().length ? button : null;
  }

  // The page product's own form on product pages; on its pages, the cards with the class the app picks
  function coveredByApp(form, holder) {
    if (isProductPage && holder === form.closest(MAIN_PRODUCT)) return true;
    if (!appCoversCards) return false;
    for (var i = 0; i < CARD_CLASSES.length; i++) {
      if (document.querySelector(CARD_CLASSES[i])) return !!form.closest(CARD_CLASSES[i]);
    }
    return false;
  }

  function readJson(response) {
    return response.ok ? response.json() : null;
  }

  // One request per batch of products, cached for the page; null for a failed request
  var products = {};
  function lookup(ids) {
    var missing = ids.filter(function (id, index) {
      return !products[id] && ids.indexOf(id) === index;
    });
    if (missing.length) {
      var request = fetch('/apps/timesact/products?productIds=' + missing.join(','), {
        headers: { Accept: 'application/json' },
      })
        .then(readJson)
        .catch(function () {
          return null;
        });
      missing.forEach(function (id) {
        products[id] = request.then(function (data) {
          if (!data) return null;
          return { product: data.products && data.products[id], templates: data.settings && data.settings.templates };
        });
      });
    }
    return Promise.all(
      ids.map(function (id) {
        return products[id];
      })
    );
  }

  // Every variant's back-in-stock setting active, as the app requires on product cards
  function isNotifyOnly(product) {
    var variants =
      product &&
      product.variants &&
      Object.keys(product.variants).map(function (id) {
        return product.variants[id];
      });
    return (
      !!(variants && variants.length) &&
      variants.every(function (variant) {
        return variant.configBIS && variant.configBIS.status === 'ACTIVE';
      })
    );
  }

  // The app's settings: loaded by the app, kept in localStorage, or requested once
  var settingsRequest = null;
  function appSettings() {
    if (window.ta && window.ta.settings) return Promise.resolve(window.ta.settings);
    try {
      var stored = JSON.parse(localStorage.getItem('settings'));
      if (stored) return Promise.resolve(stored);
    } catch (error) {}
    settingsRequest =
      settingsRequest ||
      fetch('/apps/timesact/shop/settings', { headers: { Accept: 'application/json' } })
        .then(readJson)
        .then(function (data) {
          return (data && data.settings) || {};
        })
        .catch(function () {
          return {};
        });
    return settingsRequest;
  }

  // The button name of the variant's back-in-stock template, else of the shop's default one
  function label(settings, entry) {
    var variants = entry.product.variants;
    var variant = variants[Object.keys(variants)[0]];
    var own = settings[variant.configBIS.settingsTemplate];
    var shared = entry.templates && settings[entry.templates.BIS];
    return (own && own.button && own.button.name) || (shared && shared.button && shared.button.name) || FALLBACK_LABEL;
  }

  function productUrl(item) {
    var handle = item.entry.product.handle;
    if (handle) return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + handle;
    var link = item.holder.querySelector('a[href*="/products/"]');
    return link ? link.pathname : window.location.pathname;
  }

  // The app has replaced the form's button: its own button shows (product page) or the button reads its label
  function handledByApp(form, text) {
    if (form.closest(MAIN_PRODUCT)) return !!appButton();
    var button = form.querySelector('[type="submit"]');
    return !!button && button.textContent.trim() === text;
  }

  function convert(form, text) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    form.dataset.timesactNotify = 'true';
    // As the app does on product cards: its label in place of the button's content, enabled, no Buy it now.
    // An icon-only button (a "+" named by aria-label) keeps its size: the label names it, with a bell icon.
    if (button.hasAttribute('aria-label') && !button.textContent.trim()) {
      button.setAttribute('aria-label', text);
      button.title = text;
      button.innerHTML = '<i class="ph ph-bell" aria-hidden="true"></i>';
    } else {
      button.textContent = text;
    }
    button.disabled = false;
    form.querySelectorAll('.shopify-payment-button').forEach(function (payment) {
      payment.hidden = true;
    });
  }

  var retries = 0;
  function scan() {
    var found = [];
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.timesactNotifyChecked) return;
      var holder = form.closest('[data-product-id]');
      if (!holder || !holder.dataset.productId || !form.querySelector('[type="submit"]')) return;
      form.dataset.timesactNotifyChecked = 'true';
      found.push({ form: form, holder: holder, id: holder.dataset.productId, covered: coveredByApp(form, holder) });
    });
    if (!found.length) return;

    lookup(
      found.map(function (item) {
        return item.id;
      })
    ).then(function (entries) {
      var notify = [];
      var failed = [];
      found.forEach(function (item, index) {
        item.entry = entries[index];
        if (!item.entry) failed.push(item);
        else if (isNotifyOnly(item.entry.product)) notify.push(item);
      });

      if (failed.length && retries < 3) {
        retries++;
        failed.forEach(function (item) {
          delete products[item.id];
          delete item.form.dataset.timesactNotifyChecked;
        });
        setTimeout(scan, 3000 * retries);
      }
      if (!notify.length) return;

      // Submits are blocked straight away; the label follows once the app's settings are in
      notify.forEach(function (item) {
        item.form.dataset.timesactNotifyUrl = productUrl(item);
        item.form.dataset.timesactNotifyGuard = 'true';
      });
      appSettings().then(function (settings) {
        notify.forEach(function (item) {
          var text = label(settings, item.entry);
          if (!item.covered) {
            convert(item.form, text);
            return;
          }
          setTimeout(function () {
            if (item.form.isConnected && !handledByApp(item.form, text)) convert(item.form, text);
          }, TAKEOVER_DELAY);
        });
      });
    });
  }

  // The app's form for the page's product opens once its button shows (it may still be loading; up to 30s)
  var waiting = null;
  function waitForAppButton() {
    if (waiting) return;
    var tries = 0;
    var check = function () {
      var button = appButton();
      if (!button && ++tries < 120) return;
      clearInterval(waiting);
      waiting = null;
      if (button) button.click();
    };
    waiting = setInterval(check, 250);
    check();
  }

  function openSignUp(form) {
    var url = form.dataset.timesactNotifyUrl;
    if (new URL(url, window.location.href).pathname === window.location.pathname) {
      waitForAppButton();
    } else {
      window.location.href = url + HASH;
    }
  }

  // Capture phase, so the theme's product form never receives the click or the submit. Clicks only on taken-over
  // forms: on the app's own buttons its click handler cancels the submit and opens its form.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('form[data-timesact-notify] [type="submit"]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      openSignUp(button.form);
    },
    true
  );
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-timesact-notify-guard]')) return;
      event.preventDefault();
      event.stopPropagation();
      openSignUp(form);
    },
    true
  );

  // Came from a "Sign Up To Be Notified" button elsewhere. The hash goes first: the app requests the page's
  // product at location.href + '.js', which a hash turns into the product page itself.
  if (isProductPage && window.location.hash === HASH) {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    waitForAppButton();
  }

  // Cards added later: recommendations, quick-add windows, search results
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
